import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { InvestigatorShellBarComponent } from './shell-bar/investigator-shell-bar.component';
import { InvestigatorSideNavComponent } from './side-nav/investigator-side-nav.component';

@Component({
  selector: 'investigator-layout',
  standalone: true,
  imports: [RouterOutlet, InvestigatorShellBarComponent, InvestigatorSideNavComponent],
  templateUrl: './investigator-layout.component.html',
  styleUrl: './investigator-layout.component.scss',
})
export class InvestigatorLayoutComponent {}
